import { Link, useParams, useNavigate } from 'react-router-dom';
import apiMethod from '../../../services/api-service';
import methods from '../../../services/utility';
import { useState, useEffect } from 'react';
import DeleteModal from '../../../components/deleteModal/DeleteModal';

// assets
import back from "../../../assets/images/icons/arrow-right2.svg";
import Preloading from '../../../components/basics/Preloading';

const SnappServicePrice = () => {
  const { branchId } = useParams();
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [gridData, setGridData] = useState([]);
  const [gridFilter, setGridFilter] = useState({
    branchId: branchId,
    title: '',
    code: '',
    size: 20,
    part: 1,
    total: 0,
    parts: 0
  });
  const [formModel, setFormModel] = useState({
    id: 0,
    title: '',
    description: '',
    serviceType: 0,
    isFreeTax: false,
    enabled: true,
    productId: 0,
    branchId: branchId
  });
  const [products, setProducts] = useState([]);
  const [productFilter, setProductFilter] = useState({
    branchId: branchId,
    title: '',
    code: '',
    size: 20,
    part: 1,
    total: 0,
    parts: 0
  });
  const [serviceTypes, setServiceTypes] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [showProductBox, setShowProductBox] = useState(true);

  const getGridData = async (showLoading) => {
    if (showLoading)
      setLoading(true);
    const resp = await apiMethod.getSnappServicePrices(gridFilter.branchId, gridFilter.title, gridFilter.code, gridFilter.size, gridFilter.part);
    if (showLoading)
      setLoading(false);
    if (methods.showApiErrors(resp))
      setGridData(resp.data);
  };

  const findProducts = async (spin) => {
    if (spin)
      setLoading(true);
    const resp = await apiMethod.findProducts(productFilter.branchId, productFilter.title, productFilter.code);

    if (spin)
      setLoading(false);

    if (!methods.showApiErrors(resp))
      return false;
    setProducts(resp.data);
  };

  const getBaseInfo = async () => {
    const resp1 = await apiMethod.getSnappServiceTypes();
    if (!methods.showApiErrors(resp1))
      return false;
    setServiceTypes(resp1.data);

    await findProducts(false);
  };

  useEffect(() => {
    const bindData = async () => {
      setLoading(true);
      await getBaseInfo();
      await getGridData(false);
      setLoading(false);
    }
    bindData();
  }, [branchId]);

  const mapModel = (model) => {
    formModel.id = model.id;
    formModel.title = model.title;
    formModel.description = model.description;
    formModel.serviceType = model.serviceType;
    formModel.isFreeTax = model.isFreeTax;
    formModel.enabled = model.enabled;
    formModel.productId = model.productId;
    formModel.branchId = model.branchId;
    setFormModel({ ...formModel });
  };

  const resetForm = () => {
    mapModel({
      id: 0,
      title: '',
      description: '',
      serviceType: 0,
      isFreeTax: false,
      enabled: true,
      productId: 0,
      branchId: branchId
    });
    setShowModal(false);
    setShowProductBox(true);
    setShowDeleteModal(false);
  };

  const openNewForm = async () => {
    resetForm();
    setShowModal(true);
  };

  const getItemInfo = async (id) => {
    setLoading(true);
    const resp = await apiMethod.getSnappServicePriceInfo(id);
    if (!methods.showApiErrors(resp))
      return false;

    mapModel(resp.data);
    setShowProductBox(false);
    setShowModal(true);
    setLoading(false);
  };

  const createItem = async () => {
    if (!isValidForm())
      return false;

    setLoading(true);

    try {
      const resp = await apiMethod.createSnappServicePrice(formModel);

      if (!methods.showApiErrors(resp))
        return false;

      await getGridData();

    } catch (error) {
      console.error(error);
    } finally {
      setLoading(false);
      setShowModal(false);
      setShowProductBox(false);
    }
  };

  const setProduct = (item) => {
    formModel.title = item.title;
    formModel.productId = item.id;
    formModel.description = item.description;
    setFormModel({ ...formModel });
    setShowProductBox(false);
  };

  const isValidForm = () => {
    var errors = [];
    if (methods.isNullOrEmptyString(formModel.title))
      errors.push('عنوان محصول باید مقدار داشته باشد.');

    if (formModel.productId === 0)
      errors.push('شناسه خدمت باید انتخاب شده باشد.');

    if (formModel.branchId != branchId)
      errors.push('شناسه شعبه باید مقدار داشته باشد.');

    if (formModel.serviceType === 0)
      errors.push('نوع خدمت باید انتخاب شده باشد.');

    if (errors.length > 0) {
      methods.showErrors(errors);
      return false;
    }

    return true;
  };

  const setDeleteItemModel = (item) => {
    mapModel(item);
    setShowDeleteModal(true);
  };

  const deleteItem = async () => {
    setLoading(true);
    try {
      const resp = await apiMethod.removeSnappServicePrice(formModel.id);
      if (!methods.showApiErrors(resp))
        return false;

      await getGridData();
      resetForm();
    } catch (error) {
      console.error(error);
    } finally {
      setLoading(false);
      setShowDeleteModal(false);
    }
    return true;
  };

  const changeProductBoxShow = () => {
    setShowProductBox(!showProductBox);
  };

  const changeEnableItem = async (id) => {
    setLoading(true);
    const resp = await apiMethod.enableSnappServicePrice(id);
    setLoading(false);
    if (!methods.showApiErrors(resp))
      return false;

    getGridData(true);
  };

  const resetFilters = () => {
    gridFilter.branchId = branchId;
    gridFilter.title = '';
    gridFilter.code = '';
    setGridFilter({ ...gridFilter })
  };

  const searchItem = async () => {
    setLoading(true);
    await getGridData();
    setLoading(false);
  };

  const clearSearch = async () => {
    setLoading(true);
    resetFilters();
    await getGridData();
    setLoading(false);
  };

  const callPager = async (i) => {
    setLoading(true);
    gridFilter.part = i;
    setGridFilter({ ...gridFilter });
    await getGridData();
    setLoading(false);
  };

  const movePagerPart = (isForward) => {
    if (isForward) {
      if (gridFilter.parts < gridFilter.part + 1) {
        return false;
      }
      callPager(gridFilter.part + 1);
    } else {
      if (gridFilter.part === 1) {
        return false;
      }
      callPager(gridFilter.part - 1);
    }
  };

  const makePagerItems = () => {
    let pages = [];
    for (let i = 1; i <= gridFilter.parts; i++) {
      pages.push(
        <li key={i} className={gridFilter.part === i ? 'page-item active mx-1' : 'page-item mx-1'}>
          <a className="page-link circular-pagination" onClick={() => { callPager(i) }}>
            {i}
          </a>
        </li>
      );
    }
    return pages;
  };

  const resetProductFilter = () => {
    productFilter.branchId = branchId;
    productFilter.title = '';
    productFilter.code = '';
    setGridFilter({ ...productFilter })
  };

  const searchProductItem = async () => {
    setLoading(true);
    await findProducts();
    setLoading(false);
  };

  const clearProductSearch = async () => {
    setLoading(true);
    resetProductFilter();
    await findProducts();
    setLoading(false);
  };

  const productMovePagerPart = (isForward) => {
    if (isForward) {
      if (productFilter.parts < productFilter.part + 1) {
        return false;
      }
      productCallPager(productFilter.part + 1);
    } else {
      if (productFilter.part === 1) {
        return false;
      }
      productCallPager(productFilter.part - 1);
    }
  };

  const productCallPager = async (i) => {
    setLoading(true);
    productFilter.part = i;
    setProductFilter({ ...productFilter });
    await findProducts();
    setLoading(false);
  };

  const productMakePagerItems = () => {
    let pages = [];
    for (let i = 1; i <= productFilter.parts; i++) {
      pages.push(
        <li key={i} className={productFilter.part === i ? 'page-item active mx-1' : 'page-item mx-1'}>
          <a className="page-link circular-pagination" onClick={() => { productCallPager(i) }}>
            {i}
          </a>
        </li>
      );
    }
    return pages;
  };

  const closeModal = () => {
    resetForm();
    setShowModal(false);
  };

  const renderItems = () => {
    return (
      <>
        {loading && <Preloading></Preloading>}
        {
          <>
            <div>
              <Link to={`/sale/${branchId}/snappManager`} className='d-none d-lg-block text-start mb-3 link back-link'>
                <span><img src={back} className="" alt="return" /></span>
                بازگشت
              </Link>
            </div>
            <div className='d-lg-none d-flex justify-content-between align-items-baseline saleheader'>
              <div>
                <Link to={`/sale/${branchId}/snappManager`} className='link back-link'>
                  <span><img src={back} className="" alt="return" /></span>
                </Link>
                هزینه‌های اسنپ (خدمات)
              </div>
              <p className="date">{methods.currentDate()}</p>
            </div>
            <div className='saleheader d-none d-lg-block'>
              <p>هزینه‌های اسنپ (خدمات)</p>
            </div>
            <div className="salemain">
              <div className='salesearchsection'>
                <div className='row g-1'>
                  <div className='col-12 col-md-6 col-lg-4'>
                    <label htmlFor="funit" className="form-label">عنوان</label>
                    <div className="hstack">
                      <input
                        id="searchInput"
                        className="form-control"
                        type="text"
                        aria-label="Add your item here..."
                        style={{ direction: 'rtl', textAlign: 'right' }}
                        value={gridFilter.title}
                        onChange={(e) => {
                          gridFilter.title = e.target.value;
                          setGridFilter({ ...gridFilter });
                        }}
                      />
                      <button type='button' className='btn btn-purple me-1'
                        onClick={searchItem}
                      >
                        <i className="bi bi-search"></i>
                      </button>
                      <button type='button' className='btn btn-outline-info'
                        onClick={clearSearch}
                      >
                        <i className="bi bi-arrow-clockwise"></i>
                      </button>
                    </div>
                  </div>
                  <div className='col-12 col-md-2 col-lg-4'></div>
                  <div className='col-12 col-md-4'>
                    <div className='createButton'>
                      <button
                        onClick={() => { openNewForm() }}
                        className='btn btn-outline-purple custome-btn' type='button'>
                        <span className='align-middle d-inline-block'>ایجاد خدمت اسنپ</span> <i className="bi bi-plus-circle align-middle"></i>
                      </button>
                    </div>
                  </div>
                </div>
              </div>
              <div className='table-responsive saletable'>
                <table className="table table-striped table-md " >
                  <thead className='align-middle'>
                    <tr>
                      <th scope="col vertical-center" width="20px">ردیف</th>
                      <th scope="col vertical-center">کد</th>
                      <th scope="col vertical-center">عنوان</th>
                      <th scope="col vertical-center">نوع خدمت</th>
                      <th scope="col vertical-center">محاسبه مالیات</th>
                      <th scope="col vertical-center">توضیحات</th>
                      <th scope="col vertical-center">وضعیت</th>
                      <th scope="col vertical-center" width="100px">عملیات</th>
                    </tr>
                  </thead>
                  <tbody className='align-middle'>
                    {gridData.map((item, index) => (
                      <tr key={item.id}>
                        <th scope="row">{((gridFilter.part - 1) * gridFilter.size) + index + 1}</th>
                        <td>{item.code}</td>
                        <td>{item.title}</td>
                        <td>{item.typeName}</td>
                        <td>
                          {!item.isFreeTax && <span>شامل مالیات</span>}
                          {item.isFreeTax && <span>بدون مالیات</span>}
                        </td>
                        <td>{item.description}</td>
                        <td>
                          <input
                            type="checkbox"
                            checked={item.enabled}
                            onChange={() => changeEnableItem(item.id)}
                            className="visually-hidden"
                            id={`customCheckbox-${item.id}`}
                          />
                          <label className={` ${item.enabled ? '' : ''}`} htmlFor={`customCheckbox-${item.id}`}>
                            {item.enabled ? <i className="bi bi-check-square fs-5 activePagerCheckbox"></i> : <i className="bi bi-x-square fs-5 inActivePagerCheckbox"></i>}
                          </label>
                        </td>
                        <td>
                          <button
                            onClick={() => getItemInfo(item.id)}
                            className='btn btn-sm btn-outline-purple me-2' type='button'>
                            <i className="bi bi-pencil-square"></i>
                          </button>
                          <button
                            onClick={() => setDeleteItemModel(item)}
                            className='btn btn-sm btn-outline-danger' type='button'>
                            <i className="bi bi-trash"></i>
                          </button>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
                {gridFilter.parts > 1 &&
                  <nav aria-label="Page navigation example" className='mt-5'>
                    <ul className="pagination justify-content-center">
                      <li className="page-item mx-1">
                        <a className="page-link circular-pagination" onClick={() => { movePagerPart(false) }}>
                          <i className="bi bi-chevron-compact-right"></i>
                        </a>
                      </li>
                      {makePagerItems()}
                      <li className="page-item mx-1">
                        <a className="page-link circular-pagination" onClick={() => { movePagerPart(true) }}>
                          <i className="bi bi-chevron-compact-left"></i>
                        </a>
                      </li>
                    </ul>
                  </nav>
                }
              </div>
            </div>
          </>
        }
      </>
    )
  };

  const closeDeleteModal = () => {
    setShowDeleteModal(false);
  };

  const Modal = () => {
    return (
      <div className="modal fade show" tabIndex="-1" role="dialog" style={{ display: showModal ? 'block' : 'none' }}>
        <div className="modal-dialog modal-lg" role="document" >
          <div className="modal-content px-3">
            <div className="modal-header">
              <h5 className="modal-title">ایجاد / ویرایش خدمت اسنپ</h5>
              <button
                type="button"
                className="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
                onClick={closeModal}
              >
              </button>
            </div>
            <div className="modal-body">
              {showProductBox && (
                <>
                  <div className='col-md-6'>
                    <label htmlFor="funit" className="form-label">جستجو در خدمات</label>
                    <div className="hstack">
                      <input
                        id="searchInput"
                        className="form-control"
                        type="text"
                        aria-label="Add your item here..."
                        style={{ direction: 'rtl', textAlign: 'right' }}
                        value={productFilter.title}
                        onChange={(e) => {
                          productFilter.title = e.target.value;
                          setProductFilter({ ...productFilter });
                        }}
                      />
                      <button type='button' className='btn btn-purple me-1'
                        onClick={searchProductItem}
                      >
                        <i className="bi bi-search"></i>
                      </button>
                      <button type='button' className='btn btn-outline-info'
                        onClick={clearProductSearch}
                      >
                        <i className="bi bi-arrow-clockwise"></i>
                      </button>
                    </div>
                  </div>
                  <div className='border rounded mt-4'>
                    <p className='bg-light rounded-top p-3'>انتخاب خدمت پایه</p>
                    <div className='table-responsive saletable m-3'>
                      <table className="table table-striped table-md align-middle" >
                        <thead className=''>
                          <tr>
                            <th scope="col vertical-center" width="20px">ردیف</th>
                            <th scope="col vertical-center">عنوان</th>
                            <th scope="col vertical-center">کد</th>
                            <th scope="col vertical-center" width="50px">عملیات</th>
                          </tr>
                        </thead>
                        <tbody className=''>
                          {products.map((item, index) => (
                            <tr key={item.id}>
                              <th scope="row">{((productFilter.part - 1) * productFilter.size) + index + 1}</th>
                              <td>{item.title}</td>
                              <td>{item.code}</td>
                              <td>
                                <button type="button" className="btn btn-sm btn-purple"
                                  onClick={() => setProduct(item)}
                                >
                                  افزودن
                                </button>
                              </td>
                            </tr>
                          ))}
                        </tbody>
                      </table>
                      {productFilter.parts > 1 &&
                        <nav aria-label="Page navigation example" className='mt-5'>
                          <ul className="pagination justify-content-center">
                            <li className="page-item mx-1">
                              <a className="page-link circular-pagination" onClick={() => { productMovePagerPart(false) }}>
                                <i className="bi bi-chevron-compact-right"></i>
                              </a>
                            </li>
                            {productMakePagerItems()}
                            <li className="page-item mx-1">
                              <a className="page-link circular-pagination" onClick={() => { productMovePagerPart(true) }}>
                                <i className="bi bi-chevron-compact-left"></i>
                              </a>
                            </li>
                          </ul>
                        </nav>
                      }
                    </div>
                  </div>
                </>
              )}
              {!showProductBox && (
                <>
                  <div className='mb-4'>
                    <Link onClick={() => { changeProductBoxShow() }} className='link back-link'>
                      <span><img src={back} className="" alt="return" /></span>
                      بازگشت
                    </Link>
                  </div>
                  <form className="row g-3" autoComplete="off">
                    <div className="col-md-6">
                      <label htmlFor="title" className="form-label">عنوان</label>
                      <input type="text" className="form-control" id="title" name="title"
                        value={formModel.title}
                        onChange={(e) => {
                          formModel.title = e.target.value;
                          setFormModel({ ...formModel });
                        }}
                      />
                    </div>
                    <div className="col-md-6">
                      <label htmlFor="ddlproducts" className="form-label required-label">خدمت متصل</label>
                      <select
                        id="ddlproducts"
                        className="form-select"
                        aria-label="menu"
                        value={formModel.productId}
                        onChange={(e) => {
                          formModel.productId = e.target.value;
                          setFormModel({ ...formModel });
                        }}
                      >
                        {products.map((item, index) => (
                          <option value={item.id} key={index}>{item.title}</option>
                        ))}
                      </select>
                    </div>
                    <div className="col-md-6">
                      <label htmlFor="ddltypes" className="form-label required-label">نوع خدمت</label>
                      <select
                        id="ddltypes"
                        className="form-select"
                        aria-label="menu"
                        value={formModel.serviceType}
                        onChange={(e) => {
                          formModel.serviceType = e.target.value;
                          setFormModel({ ...formModel });
                        }}
                      >
                        <option value="">انتخاب کنید</option>
                        {serviceTypes.map((item, index) => (
                          <option value={item.id} key={index}>{item.title}</option>
                        ))}
                      </select>
                    </div>
                    <div className='col-md-6'>
                      <div className="form-check mt-4 pt-3">
                        <input
                          onChange={(e) => {
                            formModel.isFreeTax = e.target.checked;
                            setFormModel({ ...formModel })
                          }}
                          checked={formModel.isFreeTax}
                          className="form-check-input" type="checkbox" id="chbtaxfree" />
                        <label className="form-check-label" htmlFor="chbtaxfree">
                          بدون محاسبه مالیات
                        </label>
                      </div>
                    </div>
                    <div className='col-md-6'>
                      <div className="form-check pt-3 mb-2">
                        <input
                          onChange={(e) => {
                            formModel.enabled = e.target.checked;
                            setFormModel({ ...formModel })
                          }}
                          checked={formModel.enabled}
                          className="form-check-input" type="checkbox" id="chbenablede" />
                        <label className="form-check-label" htmlFor="chbenablede">
                          وضعیت نمایش
                        </label>
                      </div>
                    </div>
                    <div className="col-md-12">
                      <label htmlFor="description" className="form-label">توضیحات</label>
                      <textarea type="text" className="form-control" id="description" name="description"
                        value={formModel.description || ""}
                        onChange={(e) => {
                          formModel.description = e.target.value;
                          setFormModel({ ...formModel })
                        }}
                      />
                    </div>
                  </form>
                </>
              )}
            </div>
            <div className="modal-footer">
              <button type="button" className="btn custome-btn btn-link-purple" onClick={closeModal}>
                انصراف
              </button>
              <button type="button"
                onClick={() => { createItem() }}
                className="btn custome-btn btn-purple w-25 ">ذخیره</button>
            </div>
          </div >
        </div >
      </div >
    )
  };

  return (
    <>
      {renderItems()}
      {showModal && Modal()}
      {showDeleteModal &&
        <DeleteModal
          showModal={showDeleteModal}
          closeModal={closeDeleteModal}
          deleteItem={deleteItem}
          text={'دسته‌بندی'}
        />
      }
    </>
  );
}

export default SnappServicePrice;